/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { memo } from 'react';
import { TableCell } from '@mui/material';
import { createListStyles } from './ListStyles';
import { TableTooltip } from '../../StyledComponents/TableTooltip';
import { useTranslation } from 'react-i18next';
import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { theme } from '../../../assets/style/them';

interface ColorBarCellProps {
    displayOptions: { color: string; height: number; tooltipTranslatePrefix: string; notPrefix?: boolean };
    tooltip: string;
}

const ColorBarCell = (props: ColorBarCellProps) => {
    const ListStyles = makeStyles((theme: Theme) => createStyles(createListStyles(theme)));
    const classes = ListStyles();
    const { t } = useTranslation();
    const { color, height, tooltipTranslatePrefix, notPrefix } = props.displayOptions;
    const { tooltip } = props;

    return (
        <TableTooltip
            title={tooltip ? t(notPrefix ? tooltipTranslatePrefix : tooltipTranslatePrefix + tooltip) : tooltip}
            placement="right"
            spacing={theme.spacing(0)}
        >
            <TableCell className={classes.colorBarCell}>
                <div
                    style={{
                        backgroundColor: color,
                        height: height,
                        width: 5,
                        borderRadius: 5,
                    }}
                />
            </TableCell>
        </TableTooltip>
    );
};
export default memo(ColorBarCell);
